import { Tooltip as AntTooltip, TooltipProps } from 'antd';

const Tooltip = (props: TooltipProps) => {
  return <AntTooltip color="white" overlayClassName="custom-tooltip" {...props} />;
};

export default Tooltip;
